import React from 'react';
import styled from 'styled-components';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import SettingItem from './SettingItem.jsx';
import Modal from '../Modal';
import { Button } from '../../shared/FormStyles';
import {
  SettingWrapper,
  SettingHeader,
  SettingTitle,
  SettingCreate,
  SettingItemsWrapper,
} from './StyledComponents';

const openFormModal = (FormComponent, item) => {
  return Modal({
    component: <FormComponent item={item} />,
    width: '394px',
    padding: '24px',
  });
};

const CloseModalButton = styled(Button)`
  align-self: flex-end;
`;

const SettingList = ({ settingName, collection, form, onDelete }) => {
  const { t } = useTranslation(['edit', 'shared']);

  return (
    <SettingWrapper>
      <SettingHeader>
        <SettingTitle>
          {`${t('edit:settingList:title', { settingName: settingName })}s`}
        </SettingTitle>
        <SettingCreate onClick={() => openFormModal(form)}>
          {t('edit:settingList:create', { settingName: settingName })}
        </SettingCreate>
      </SettingHeader>
      <SettingItemsWrapper>
        {collection.map((item, index) => (
          <SettingItem
            key={index}
            item={item}
            deleteItem={onDelete}
            editItem={() => openFormModal(form, item)}
          />
        ))}
      </SettingItemsWrapper>
      <CloseModalButton variant="containedBlue" onClick={() => Swal.close()}>
        {t('shared:cancel')}
      </CloseModalButton>
    </SettingWrapper>
  );
};

export { SettingList };

export default SettingList;
